import { usePresentationGuideStore } from "@/stores/presentation-guide-store";

/** A submitted guide outlives the model execution that created it. Its cursor
 * remains the user's control surface until the local guide ends. */
export function isActiveGuideCursor(
  cursor: { presentationDeliveryId?: string } | undefined,
): boolean {
  const activeId = usePresentationGuideStore.getState().guide?.presentationId;
  return Boolean(activeId && cursor?.presentationDeliveryId === activeId);
}
